"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sum = sum;
function sum(items) {
    return items.reduce((a, b) => a + b, 0);
}
//# sourceMappingURL=sum.js.map